import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import {
  Button,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import ReactToPrint from "react-to-print";
import { GET, POST } from "../../helper/api";

import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Table from "../../components/react-table/Table";
import { getToken } from "../../helper/auth";


const IngredientExchangeHistoryReport = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [smOption, setSmOption] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [data, setData] = useState({
    total: []
  });
  const [timeNow, setTimeNow] = useState();
  const [filter, setFilter] = useState({
    date: searchParams.get("date") || moment().format("YYYY-MM-DD"),
  })

  useEffect(() => {
    GET(`/warehouse`, {}, true).then(({ data: { rows } }) => {
      setWarehouses(rows);
    });
  }, []);

  useEffect(() => {

    const newParams = new URLSearchParams({
      date: moment(filter.date).format('YYYY-MM-DD')
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    const params = {
      date: moment(filter.date).format('YYYY-MM-DD'),
    }

    GET(
      `/ingredient-exchange/report`,
      params,
      true
    ).then(({ data: { data } }) => {
      const newData = {};
      Object.entries(data).forEach(([key, value]) => {
        newData[key] = Object.values(value);
      })
      setData(newData);
    });
  }, [filter, timeNow]);

  const updateIngredientExchangeHistory = () => {
    POST(
      `/ingredient-exchange/save_ingredient_exchange_history_previous_month`, {}, {}, true
    ).then(() => {
      toast.success('Cập nhật thành công')
      setTimeNow(moment().valueOf())
    });
  }

  const colTable = [
    {
      Header: "Tên hàng",
      accessor: (item) => item.ingredientName
    },
    {
      Header: "Tồn đầu",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.firstWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    },
    {
      Header: "Nhập trong kỳ",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    },
    {
      Header: "Xuất trong kỳ",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    },
    {
      Header: "Xuất sản xuất",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.produceOutWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    },
    {
      Header: "Nhập sản xuất",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.produceInWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    },
    {
      Header: "Tồn cuối kỳ",
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lastWeight || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={0}
      />
    },
  ];

  const exportExcel = () => {
    const params = new URLSearchParams({
      date: moment(filter.date).format("YYYY-MM-DD"),
      token: getToken(),

    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/ingredient-exchange/report-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Báo cáo"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input placeholder="Lọc theo ngày" onChange={(e) => {
                          setFilter({
                            ...filter,
                            date: moment(e.target.value).format("YYYY-MM-DD")
                          });
                        }} value={filter.date} type="date" className="form-control" />
                      </div>
                    </li>
                    <li>
                      <div className="d-inline-block mr-3">
                        <ReactToPrint
                          trigger={() => <Button>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3">
                          Xuất excel
                        </Button>

                        <Button onClick={updateIngredientExchangeHistory} className="ml-3">
                          Cập nhật lại đầu kỳ
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <div className="my-3" ref={printRef}>

          <Block>
            <div
              id="DataTables_Table_1_wrapper"
              className="dataTables_wrapper dt-bootstrap4 no-footer bg-white"
            >
              <Row>
                <Col md={12}>
                  <div>
                    <h5 className="text-center mt-2">Báo cáo  ngày {moment(filter.date).format('DD-MM-YYYY')}</h5>

                  </div>
                </Col>
                {
                  warehouses.map((warehouse) => (
                    <Col md={12}>
                      <h5 className="text-center"> Kho {warehouse.name}</h5>
                      {
                        data?.[warehouse.id]?.length > 0 && (
                          <Table
                            conditionHighlightRow={(row) => row.ingredientId === 'total' ? 'font-weight-bold ' : ''}
                            columns={colTable}
                            data={data[warehouse.id]}
                            notShowPagi={true}
                          ></Table>
                        )
                      }

                    </Col>
                  ))
                }
                {data.total?.length > 0 && (
                  <Col md={12}>
                    <h5 className="text-center"> Tổng cộng</h5>
                    <Table
                      conditionHighlightRow={(row) => row.ingredientId === 'total' ? 'font-weight-bold ' : ''}
                      columns={colTable}
                      data={data.total}
                      notShowPagi={true}
                    ></Table>
                  </Col>
                )}

              </Row>
            </div>
          </Block>
        </div>

      </Content>
    </React.Fragment>
  );
};

export default IngredientExchangeHistoryReport;
